import { ENDPOINTS } from '../constants/endpoints'
import type { AxiosResponse } from 'axios'
import type {
  Member,
  MemberCreateInput,
  MemberUpdateInput,
} from '../types/member'
import axiosInstance from '@/integrations/axios/axios-instance'

export const membersApi = {
  getMembers: (): Promise<AxiosResponse<{ members: Array<Member> }>> => {
    const endpoint = ENDPOINTS.GET_MEMBERS
    return axiosInstance.get(endpoint)
  },
  getMember: (memberId: string): Promise<AxiosResponse<{ member: Member }>> => {
    const endpoint = `${ENDPOINTS.GET_MEMBER}/${memberId}`
    return axiosInstance.get(endpoint)
  },
  createMember: (
    member: MemberCreateInput,
  ): Promise<
    AxiosResponse<{
      message: string
      member: Member
      hadUpdatedDonations: boolean
    }>
  > => {
    const endpoint = ENDPOINTS.CREATE_MEMBER
    return axiosInstance.post(endpoint, member)
  },
  updateMember: (
    member: MemberUpdateInput,
  ): Promise<AxiosResponse<{ message: string; member: Member; hadUpdatedDonations: boolean }>> => {
    const endpoint = `${ENDPOINTS.UPDATE_MEMBER}/${member._id}`
    return axiosInstance.put(endpoint, member)
  },
  deleteMember: (
    memberId: string,
  ): Promise<AxiosResponse<{ message: string; id: string }>> => {
    const endpoint = `${ENDPOINTS.DELETE_MEMBER}/${memberId}`
    return axiosInstance.delete(endpoint)
  },
}
